
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/us/sub/mobile-responsive",
      function () {
        return require("private-next-pages/us/sub/mobile-responsive.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/us/sub/mobile-responsive"])
      });
    }
  